import { ElementRef } from '@angular/core';
import { MissionEC } from './mission';
import { Convention } from './convention';
import { Options, Select } from '../utilities/utilities.model';
import { CompteSurEntite, QueovalBase, QueovalDate } from '../global/class.global';
import { QueovalDateService } from '../../services/queovalDate.service';

export class Index {
  [index: string]: any;
}

export enum Iban {
  codePays = 0,
  cleIban = 1,
  codeBanque = 2,
  codeGuichet = 3,
  numeroCompte = 4,
  cleRib = 5
}

export enum TypeLine {
  libre = 0,
  auto = 1,
  temps = 2,
  proforma = 3
}

export enum bic {
  codeBanqueBic = 0,
  codePaysBic = 1,
  codeLocalisationBic = 2,
  codeOptionnelBic = 3,
}

export enum ModeRequest {
  save = 0,
  update = 1,
  delete = 2
}

export enum TypeRemise {
  pourcent = 0,
  montant = 1,
  aucune = 2

}

export enum Mode {
  auto = 0,
  libre = 1,
  validation = 2
}

export enum RemonterPrestationFact {
  creation = 0,
  cloture = 1,
  validation = 2
}

export class TvaGlobal {
  base: number;
  taux: Select;
  tva: number;
  txFrais: number;
   constructor() {
    this.base = 0;
    this.taux = new Select();
    this.tva = 0;
    this.txFrais = 0;
   }
}

export class Total extends TvaGlobal {
  totalTTC: number;
  acompte: number;
  netAPayer: number;
  constructor() {
    super();
    this.totalTTC = 0;
    this.acompte = 0;
  }
}

export class IbanBicParameters{
  value: string;
  maxLength: number;
  element: ElementRef;
}


export class Remise {
  value: number;
  type: TypeRemise;
}

//export class QueovalDate {
//  annee: string;
//  mois: string;
//  jour: string;
//}

export class Echeancier {
  date: Date | null;
  value: number;
  idBo: string;

  constructor() {
    this.date = new Date();
    this.value = 0;
    this.idBo = '0';
  }
}

export class TempsPasse
{
    public ident: string;
    public libelle: string;
    public idFact: string;
    public couts: string;
    public temps: string;
    public date: string;
    public activite: string;
    public liee: boolean;
    public idReserv: string;
    public idContact: string;

    constructor() {
      this.ident = '';
      this.libelle = '';
      this.idFact = '';
      this.idReserv = '';
      this.idContact = '';
      this.couts = '0';
      this.temps = '0';
      this.date = '01/01/0001';
      this.activite = '';
      this.liee = false;
    }
}

export class CalculEcheance {
  montantHT: number;
  nbreOccurence: number;
  periodicite: Select;
  dateDebut: Date | null;
  montantTotalHT: number;
  montantHtUnitaire: number;
  montantHtRemise: number;
  quantite: number;
  unite: Select;
  constructor() {
    this.montantHT = 0;
    this.nbreOccurence = 1;
    this.periodicite = { id: '0', value: '---------' };
    this.dateDebut = new Date();
    this.montantTotalHT = 0;
    this.montantHtUnitaire = 0;
    this.montantHtRemise = 0;
    this.quantite = 1;
    this.unite = { id: '0', value: '---------' };
  }
}

export class CoordBanque {
  id: string;
  iban: string;
  bic: string;
  mandat: string;
  dateSignature: Date | null;
  nouveauMandat: string;
  nouvelleDateSignature: Date | null;
  etatSepa: Select;

  constructor() {
    this.id = '0';
    this.iban = '';
    this.bic = '';
    this.mandat = '';
    this.dateSignature = new Date();
    this.nouveauMandat = '';
    this.nouvelleDateSignature = new Date();
    this.etatSepa = { id: '0', value: '---------' };
  }
}


export class ModeDeFacturation
{
    id: string;

    entiteFacturation: Select;
    groupeFacturation: Select;
    groupeLigne: Groupe;
    article: Article;
    type: TypeLine;
    groupeFamille: Select;
    nbreOccurence: number;
    periodicite: Select;
    dateDebutFacturation: QueovalDate;
    montantHT: number;

    jourFacture: number;
    facturationFindemois: boolean
    //factureMoisPlus1: boolean;

    origine: string;
    ordreLigne: Select;
    modeReglement: Select;
    reglementMoisPlus1: boolean;
    jourReglement: number;
    periodiciteReglement: Select;
    nbreOccurenceReglement: number;
    dateReglement: QueovalDate;
    montantHTReglement: number;

    bloquerFacturation: boolean;

    constructor() {
      this.id = '0';
      // Facturation
      this.ordreLigne = { id: '0', value: '---------' };
      this.groupeLigne = ({ id: '0', value: '---------', code: '0' } as Groupe);
      this.dateDebutFacturation = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), new Date().getDay().toString());
      this.entiteFacturation = { id: '0', value: '---------' };
      this.groupeFacturation = { id: '0', value: '---------' };
      this.article = ({ id: '0', value: '---------', title: '', tva: '', debours: false, excluBpf: false, isBareme: false } as Article);
      this.type = TypeLine.auto;
      this.groupeFamille = { id: '0', value: '---------' };
      this.nbreOccurence = 1;
      this.periodicite = { id: '0', value: '---------' };
      this.jourFacture = 1;
      this.facturationFindemois = false;
      //this.factureMoisPlus1 = false;
      this.nbreOccurenceReglement = 0;
      this.origine = '';
      // Reglement
      this.dateReglement = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), new Date().getDay().toString());
      this.modeReglement = { id: '0', value: '---------' };
      this.reglementMoisPlus1 = false;
      this.jourReglement = 0;
      this.periodiciteReglement = { id: '0', value: '---------' };
      this.montantHT = 0;
      this.montantHTReglement = 0;
      this.bloquerFacturation = false;
    }
}

export class Acompte
{
    ident: string;
    objetFacturable: string;
    montant: number;
    montantUtilise: number;
    libelle: string;
    typeReg: string;
    idLigneAcompte: string;
    // uniquement utilisé par le serveur
    ligneMontant: number;
    idDonneurOrdre: string;
    idFinanceur: string;

    constructor() {
      this.ident = '0';
      this.objetFacturable = '0';
      this.montant = 0;
      this.montantUtilise = 0;
      this.libelle = '';
      this.typeReg = '';
      this.idLigneAcompte = '0';
      this.ligneMontant = 0;
      this.idDonneurOrdre = '';
      this.idFinanceur = '';
    }
}

export class Adresse {
  public type: string;
  public aLattentionDe: string;
  public complement: string;
  public designation: string;
  public adresse1: string;
  public adresse2: string;
  public adresse3: string;
  public codePostal: string;
  public ville: string;
  public latitude: number;
  public longitude: number;
  public pays: string;

  constructor() {
    this.aLattentionDe = '';
    this.complement = '';
    this.designation = '';
    this.adresse1 = '';
    this.adresse2 = '';
    this.adresse3 = '';
    this.codePostal = '';
    this.ville = '';
    this.latitude = 0;
    this.longitude = 0;
    this.pays = '';
  }
}

export class DataSave {
  client: Select;
  financeur: Select;
  contactFacturation: Select;
  modeFacturation: ModeDeFacturation;

  typePrelevement: Select;

  idFacture: string;
  titreFacture: string;
  idLigneFrais: string;

  affaire: Select;
  convention: Select;
  mission: Select;
  prestation: Select;
  devis: Select;
  stage: Select;
  missionPrestation: Select;
  toolTipObjetFacturable: string;

  millesimeMission: Millesime;
  montantHtMission: number;
  dateDebutMission: Date | QueovalDate;
  montantTTCSolde: number;
  montantNewSolde: number;
  montantTTCSoldeARegle: number;
  montantTTCSoldeRegle: number;
  montantHtEcheance: number;

  echeancier: Array<Echeancier>;
  acompte: Array<Acompte>;

  millesime: string;
  codeAnalytique: string;

  article: Article;
  dateFacturation: Select;
  txFrais: number;

  calculEcheance: CalculEcheance;
  commentaire: string;

  // Pour savoir dans quel contexte on est ('1' si on est dans le contexte du client)
  modeContext: string;

  // Pour savoir si la facture est authorisée à être validée
  isAuthorizedToValid: boolean;

  constructor() {
    this.client = { id: '0', value: '---------'};
    this.financeur = { id: '0', value: '---------' };
    this.contactFacturation = { id: '0', value: '---------' };
    this.affaire = {id: '0', value: '---------'};
    this.typePrelevement = {id: '0', value: '---------'};
    this.convention = {id: '0', value: '---------'};
    this.mission = {id: '0', value: '---------'};
    this.prestation = {id: '0', value: '---------'};
    this.devis = { id: '0', value: '---------' };
    this.stage = { id: '0', value: '---------' };
    this.millesimeMission = ({ id: '0', value: '---------', montantHT: 0, montantHtEcheance: 0, montantHtUnitaire: 0, montantHtRemise: 0, quantite: 1, unite: { id: '0', value: '---------' } } as Millesime);
    this.missionPrestation = {id: '0', value: '---------'};
    this.toolTipObjetFacturable = '';
    this.echeancier = new Array<Echeancier>();
    this.acompte = new Array<Acompte>();
    this.idFacture = '0';
    this.titreFacture = '';
    this.modeFacturation = new ModeDeFacturation();
    this.montantHtMission = 0;
    this.txFrais = 0;
    this.calculEcheance = new CalculEcheance();
    this.commentaire = '';
    this.dateFacturation = {id: '0', value: '---------'};
    this.montantTTCSolde = 0;
    this.montantTTCSoldeARegle = 0;
    this.montantNewSolde = 0;
    this.montantTTCSoldeRegle = 0;
    this.montantHtEcheance = 0;
    this.modeContext = '0';
    this.codeAnalytique = '';
    this.isAuthorizedToValid = false;
  }
}

export class Formulaire {
    code: string;
    montant: number;
    unite: Array<Select>;

    typePeriodicite: Array<Select>;
    ordreLigne: Array<Select>;
    periodicite: number;
    dateFacturation: Array<Select>;
    mensualite: number;
    factureSeparee: boolean;
    groupeFamille: Array<Select>;
    jFactureMplus1: boolean;
    jPrelevementMplus1: boolean;
    echancier: boolean;
    nbrePrelevement: number;
    idTypeFacture: string;
    typePrelevement: Array<Select>;
    typePrestation: Array<Select>;
    groupeLigne: Array<Groupe>;
    acompte: Array<Acompte>;

    article: Array<Article>;
    txTva: Array<Select>;
    modeReglement: Array<Select>;

    financeur: Select;
    listContactFacturation: Array<Select>;
    adresseFinanceur: Adresse;
    adresseFinanceurFacturation: Adresse;
    adresseAffaireFacturation: Adresse;
    adresseFacturation: Adresse;

    coordBancaire: CoordBanque;
    compteSurEntite: Array<CompteSurEntite>;
    compte: string;
    entite: Array<Entite>;
    groupeFacturation: Array<Select>;
    periode: Array<Select>;

    convention: Array<ObjetFact>;
    devis: Array<ObjetFact>;
    affaire: Array<ObjetFact>;
    mission: Array<ObjetFact>;
    stage: Array<ObjetFact>;
    prestation: Array<ObjetFact>;

    millesimeMission: Array<Millesime>;

    client: Select;
    compteCli: string;
    typeRemise: Array<Select>;
    typeFacture: Array<Select>;
    etatSepa: Array<Select>;

    etatFacture: Array<Select>;

    produitTacheAffaire: ProduitTacheAffaire;

  constructor() {
      this.client = new Select('0', '');
      this.financeur = new Select('0', '');
      this.listContactFacturation = new Array<Select>({ id: '0', value: '--------' });
      this.groupeFamille = new Array<Select>();
      this.typeFacture = new Array<Select>();
      this.dateFacturation = new Array<Select>();
      this.etatSepa = new Array<Select>({id: '0', value: '--------'});

      this.convention = new Array<ObjetFact>();
      this.devis = new Array<ObjetFact>();
      this.mission = new Array<ObjetFact>();
      this.stage = new Array<ObjetFact>();
      this.affaire = new Array<ObjetFact>();
      this.prestation = new Array<ObjetFact>();

      this.periode = new Array<Select>({id: '0', value: '--------'});
      this.groupeFacturation = new Array<Select>({id: '0', value: '--------'});
      this.article = new Array<Article>(({ id: '0', value: '--------', title: '', tva: '', debours: false, excluBpf: false, isBareme: false} as Article));
      this.millesimeMission = new Array<Millesime>();
      this.compteSurEntite = new Array<CompteSurEntite>();
      this.compteCli = '';      
      this.adresseFinanceur = new Adresse();
      this.adresseFacturation = new Adresse();
      this.coordBancaire = new CoordBanque();
      this.acompte = new Array<Acompte>();
      this.groupeLigne = new Array<Groupe>();
      this.entite = new Array<Entite>();
      // initialisation du select des types de remises
      this.typeRemise = new Array<Select>(
        {id: '2', value: '----'},
        {id: '1', value: '€'},
        {id: '0', value: '%'}
      );
      this.etatFacture = new Array<Select>();
      this.produitTacheAffaire = new ProduitTacheAffaire();
      this.typePrestation = new Array<Select>();
    }
  }

export class ProduitTacheAffaire {

  public article: Select;
  public tache: Select;
  public produit: Select;
  public unite: Select;
  public montantTotal: number;
  public montantFacture: number;
  public montantResteAFacturer: number;
  public millesime: string;
  public dateFacturation: QueovalDate;

  constructor() {
    this.article = new Select();
    this.tache = new Select();
    this.produit = new Select();
    this.unite = new Select();
    this.montantTotal = 0;
    this.montantFacture = 0;
    this.montantResteAFacturer = 0;
    this.millesime = '';
    this.dateFacturation = new QueovalDate();
  }
}

export class ObjetFact extends Select
{

  public devis: Array<ObjetFact>;
  public client: Select;
  public financeur: Select;  
  public adresse: Adresse;

  constructor(id = '0', value = '--------', devis = new Array<ObjetFact>(), client = new Select(), financeur = new Select(), adresse = new Adresse()) {
    super(id, value);   
    this.devis = devis;
    this.client = client;
    this.financeur = financeur;    
    this.adresse = adresse;
  }
}


export class Millesime extends Select {

  public montantHT: number;
  public montantHtEcheance: number;
  public montantHtUnitaire: number;
  public montantHtRemise: number;
  public quantite: number;
  public unite: Select;

  constructor() {
    super();
    this.montantHT = 0;
    this.montantHtEcheance = 0;
    this.montantHtUnitaire = 0;
    this.montantHtRemise = 0;
    this.quantite = 1;
    this.unite = new Select();
  }
}


export class Entite extends Select {

  public numeroCompte: string;
  public dateDerniereValidation: Date;
  public isFull: boolean;
  public isDso: boolean;  
  public groupes: Array<Select>;

  constructor() {
    super();
    this.numeroCompte = '';
    this.dateDerniereValidation = new Date();
    this.isFull = false;
    this.isDso = false;
    this.groupes = new Array<Select>();
  }
}

  export class GroupeFactureModel {
    lignesFactures: Array<LigneFacture>;
    ligneGroupe: LigneFacture;

    constructor() {
      this.lignesFactures = new Array<LigneFacture>();
      this.ligneGroupe = new LigneFacture();
    }
  }

  export class Article extends Select {
    title: string;
    tva: string;
    debours: boolean;
    excluBpf: boolean;
    isBareme: boolean;

    constructor() {
      super();
      this.title = '';
      this.tva = '';
      this.debours = false;
      this.excluBpf = false;
      this.isBareme = false;
    }
  }

  export class Groupe extends Select {
    code: string;
    constructor() {
      super();
    }
  }

  export class InfoBoFact {
    idFils: string;
    idPere: string;
    idRelation: string;
    idBo: string;
    idBODisplay: string;
  }

  export class LigneFacture {
    id: string;
    numeroFacture: string;

    description: string;
    commentaire: string;
    type: TypeLine;
    dateFacturation: any;
    millesime: string;
    ordreLigne: number;
    groupeFamille: Select;
    quantite: number;
    unite: Select;

    typeRemise: Select;
    remise: Remise;

    txTva: Select;

    prixUnitaire: number;
    montantHT: number;
    montantTTC: number;
    montantTVA: number;

    txFrais: number;
    montantFraisHT: number;
    montantFraisTTC: number;
    montantFraisTVA: number;

    entiteFacturation: Select;
    groupeFacturation: Select;

    article: Article;
    codeAnalytique: string;
    modeReglement: Select;
    echeanceReglement: boolean;
    dateReglement: QueovalDate;

    groupeLigne: Groupe;
    oldIdGroupe: string;

    ordreGroupe: number;
    oldOrdreGroupe: number;
    oldOrdreLigne: number;

    idOriginalLigne: string;
    excludeBpf: boolean;
    lectureSeule: boolean;
    mission: Select;

    tempsPasse: Array<TempsPasse>;
    montantTempsPasse: number;


    client: Select;
    financeur: Select;

    deleted: boolean;

    constructor() {
      this.id = '0';
      this.numeroFacture = '0';
      this.millesime = String(new Date().getFullYear());

      this.unite = new Select('0', '');
      this.modeReglement = new Select('0', '');
      this.txTva = new Select('0', '');
      this.typeRemise = new Select('2', '----');
      this.mission = new Select('0', '-------');
      this.groupeFamille = new Select('0', '-------');
      this.type = 0;
      this.numeroFacture = '';
      this.entiteFacturation = new Select('0', '-------');
      this.groupeFacturation = new Select('0', '-------');
      this.article = ({ id: '0', value: '--------', title:'', tva: '', debours: false, excluBpf: false, isBareme: false } as Article);
      this.prixUnitaire = 0;
      this.montantHT = 0;
      this.montantTTC = 0;

      this.txFrais = 0;
      this.montantFraisHT = 0;
      this.montantFraisTTC = 0;
      this.montantFraisTVA = 0;

      this.description = '';
      this.quantite = 1;
      this.remise = {value: 0, type: 0};
      this.echeanceReglement = false;
      this.commentaire = '';
      this.dateFacturation = new Date();
      this.remise = new Remise();
      this.groupeLigne = new Groupe();
      this.ordreGroupe = 0;
      this.ordreLigne = 0;
      this.oldOrdreGroupe = 0;
      this.oldOrdreLigne = 0;
      this.excludeBpf = false;
      this.lectureSeule = false;
      this.tempsPasse = new Array<TempsPasse>();
      this.montantTempsPasse = 0;
      this.commentaire = '';
      this.client = new Select('', '');
      this.financeur = new Select('', '');

    }
  }


  export class LinksFacturationModel {
    title: string;
    ico: string;
    route: string;
    param: any;
}

export class PreparationFacture {
  idFactures: Array<string>;
  public listFactureGoCardLess: Array<string>; 
  periodeFacturation: QueovalDate;
  entiteFacturation: Select;
  groupeFacturation: Select;
  groupeFamille: Select;
  financeur: Select;
  preparationEnCours: boolean;
  newDateFacturation: QueovalDate;

  constructor() {
    this.idFactures = new Array<string>();
    this.listFactureGoCardLess = new Array<string>();
    this.periodeFacturation = new QueovalDateService().Now();
    this.entiteFacturation = new Select('', '');
    this.groupeFacturation = new Select('', '');
    this.groupeFamille = new Select('', '');
    this.financeur = new Select('', '');
    this.newDateFacturation = new QueovalDateService().Now();
  }
}

export class PrestationFacture {
  valid: Array<{id: string, value: boolean}>;
  cloture: Array<{id: string, value: boolean}>;
  line: Array<string>;
  modeRemonterPrestationFact: RemonterPrestationFact;

  constructor() {
    this.valid = new Array<{id: string, value: boolean}>();
    this.cloture = new Array<{id: string, value: boolean}>();
    this.line = new Array<string>();
    this.modeRemonterPrestationFact = 1;
  }
}


  export class ModeFacturationModel extends QueovalBase  {
    dataSave: DataSave;
    formulaire: Formulaire;
    groupeFacture: Array<GroupeFactureModel>;
    lignes: Array<LigneFacture>;
    idFacture: Array<string>;
    preparation: PreparationFacture;
    infoBo: InfoBoFact;
    prestation: PrestationFacture;    

    constructor() {
      super();
      this.dataSave = new DataSave();
      this.formulaire = new Formulaire();
      this.groupeFacture = new Array<GroupeFactureModel>();
      this.lignes = new Array<LigneFacture>();
      this.idFacture = new Array<string>();
      this.preparation = new PreparationFacture();
      this.infoBo = new InfoBoFact();
      this.prestation = new PrestationFacture();      
    }
}

/**
 * Modèle servant à conserver les filtres de recherche sur les factures (pour qu'elles soient sélectionnées quand on revient dessus)
 */
export class FacturationSearchData {
  dateDebut: QueovalDate;
  dateFin: QueovalDate;
  listeSearchMode: Options[];
  searchModeFilter: string;
  filtreRequestCg: string;
  filtreHaving: string;
  filtreFacture: string;
  filtreClient: string;
  textClient: string;
  selectedEntite: string;
  selectedGroupFact: string;
  selectedEtatFact: string;
  constructor() {
    this.listeSearchMode = [
      { selected: true, text: 'Rechercher toutes les factures', value: 'TOUTE' },
      { selected: false, text: 'Rechercher les factures non soldées (HORS PRELEVEMENT)', value: 'HPREL' },
      { selected: false, text: 'Rechercher les factures non soldées', value: 'NONSOLDE' },
      { selected: false, text: 'Rechercher uniquement les factures soldées', value: 'SOLDE' },
    ];
    //this.dateDebut = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), '1');
    //this.dateFin = new QueovalDateService().Now();
    // Demande du 15/06/20 : Utilisation année calendaire par défaut
    // Demande du 28/12/22 : Pas de filtre sur l'etat
    this.dateDebut = new QueovalDate(new Date().getFullYear().toString(), '1', '1');
    this.dateFin = new QueovalDate(new Date().getFullYear().toString(), '12', '31');
    this.searchModeFilter = '';
    this.filtreFacture = '';
    this.filtreClient = '';
    this.textClient = '';
    this.selectedEntite = '';
    this.selectedGroupFact = '';
    this.selectedEtatFact = '';
  }
}

/**
 * Modèle servant à conserver les filtres de recherche sur les missions (pour qu'elles soient sélectionnées quand on revient dessus)
 */
export class MissionSearchData {
  dateDebut: QueovalDate;
  dateFin: QueovalDate;
  filtreRequestCg: string;
  filtreHaving: string;
  filtreMillesime: string;
  selectedEntite: string;
  selectedTypeResp: string;
  selectedCollabo: string;
  showAllMissions: boolean;
  listMission: MissionEC[];
  constructor() {

    this.dateDebut = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() - 2).toString(), '1');
    this.dateFin = new QueovalDateService().Now();
    this.listMission = new Array<MissionEC>();
    this.filtreMillesime = '';
    this.selectedEntite = '0';
    this.selectedTypeResp = '';
    this.selectedCollabo = '';
    this.showAllMissions = false;
  }
}

/**
 * Modèle servant à conserver les filtres de recherche sur les conventions (pour qu'elles soient sélectionnées quand on revient dessus
 */
export class ConventionSearchData {
  IsDateDebutSelected: boolean;
  dateDebutDu: QueovalDate;
  dateDebutAu: QueovalDate;
  IsDateFinSelected: boolean;
  dateFinDu: QueovalDate;
  dateFinAu: QueovalDate;
  filtreRequestCg: string;
  filtreHaving: string;
  filtreClient: string;
  textClient: string;
  filtreTitreStage: string;
  selectedEntite: string;
  selectedTypeStage: string;
  selectedCycle: string;
  selectedNumeroStage: string;
  showAllConventions: boolean;
  listConvention: Convention[];
  constructor() {

    this.IsDateDebutSelected = true;
    this.dateDebutDu = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() - 2).toString(), '1');
    this.dateDebutAu = new QueovalDateService().Now();

    this.IsDateFinSelected = false;
    this.dateFinDu = new QueovalDateService().Now();      
    this.dateFinAu = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 4).toString(), '1');

    this.listConvention = new Array<Convention>();
    this.selectedEntite = '0';
    this.selectedTypeStage = '0';
    this.selectedCycle = '0';
    this.selectedNumeroStage = '0';
    this.filtreClient = '';
    this.showAllConventions = false;
  }
}

